import React from 'react';

import { Group, Text } from '@mantine/core';
import { AthleteClassMeta } from 'hooks/athleteClass/useAthleteClassMeta';

interface AthleteClassStateLabelProps {
  athleteClassMeta: AthleteClassMeta;
  size?: 'md' | 'lg' | 'xl';
}

const AthleteClassStateLabel = ({
  athleteClassMeta,
  size = 'md',
}: AthleteClassStateLabelProps): JSX.Element => {
  const { stateText, color, Icon = null } = athleteClassMeta;
  const spacing = size === 'md' ? 4 : size === 'lg' ? 6 : 8;
  const iconSize = size === 'md' ? 16 : size === 'lg' ? 20 : 24;

  return (
    <Text weight='bold' color={color} size={size}>
      <Group spacing={spacing} align='center' pr={Icon ? spacing : 0}>
        {Icon && <Icon size={iconSize} />}
        {stateText}
      </Group>
    </Text>
  );
};

export default AthleteClassStateLabel;
